import { createEffect, sample } from 'effector';
import { CreateSavedAddressRequest } from '../api/CreateSavedAddressRequest';
import { SavedAddressItem } from '../api/GetSavedAddressesResponse';
import { savedAddressesApi } from '../api/savedAddressesApi';
import { getSavedAddressesFx } from './getSavedAddressesFx';

export const createSavedAddressFx = createEffect<
  CreateSavedAddressRequest,
  SavedAddressItem
>((body) => savedAddressesApi.createSavedAddress(body));

sample({
  clock: createSavedAddressFx.doneData,
  target: getSavedAddressesFx,
});
